import React from "react";
import AppVersion from "../AppVersion";
import { ApplicationName } from "../Constants";
export default function FooterBottom(){
  return (
    <div style={{fontSize: 13, textAlign: "center", paddingTop: 25, paddingBottom: 10}}>
      <div>Website Version: <AppVersion/></div>
      <div>&copy;<>{new Date().getFullYear()} {ApplicationName}</></div>
    </div>
  );
};